import React from 'react';
import { IUser, IUserStats } from '@pvplevelup/core/dist/interfaces/IUser';
import PlaceHolderImage from 'assets/images/icons/no_profile.jpg';
import { ProfileHeader, rankValue, mmrValue } from 'components/Profile/ProfileHeader';

interface Props {
  user: IUser | undefined | null;
  userStats: IUserStats | undefined;
  fieldStats: IUserStats | undefined;
  lastGame: string;
}

const UserHeader: React.FC<Props> = ({user, lastGame,userStats,fieldStats}) => {
	return (
    <ProfileHeader
      image={user?.avatar || PlaceHolderImage}
      roundImage
      accent="#1e88e5"
      title={user?.displayname}
      subtitle="Player"
      meta={lastGame ? `Last game ${lastGame}` : 'No games yet'}
      stats={[
        {label: 'Ranked Rank', value: rankValue(user?.ranked_ranking)},
        {label: 'Ranked MMR', value: mmrValue(user?.ranked_mmr)},
        {label: 'Unranked Rank', value: rankValue(user?.unranked_ranking)},
        {label: 'Unranked MMR', value: mmrValue(user?.unranked_mmr)},
      ]}
    />
	);
};

export {UserHeader};
